import * as ActionType from "./shippingMethod.type";

const initialState = {
  shippingMethod: [],
};

export const shippingMethodReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_SHIPPING_METHOD:
      return {
        ...state,
        shippingMethod: action.payload,
      };
    case ActionType.CREATE_SHIPPING_METHOD:
      let data = [...state.shippingMethod];
      data.unshift(action.payload);
      return {
        ...state,
        shippingMethod: data,
      };
    case ActionType.UPDATE_SHIPPING_METHOD:
      return {
        ...state,
        shippingMethod: state.shippingMethod.map((data) =>
          data._id === action.payload.id ? action.payload.data : data
        ),
      };
    case ActionType.DELETE_SHIPPING_METHOD:
      return {
        ...state,
        shippingMethod: state.shippingMethod.filter(
          (data) => data._id !== action.payload && data
        ),
      };
    default:
      return state;
  }
};
